import { Table, TableBody, TableHead, TableRow } from 'components/Table';
import styles from './styles/GameScoringSummary.module.scss';
import { useGameContainer } from '../index';
import cn from 'classnames';
import useScreenSize from 'hooks/useScreenSize';
import TeamImage from '../../../components/TeamImage';
import groupBy from 'helpers/groupBy';
import ContentSection, { ContentSectionFooterButton, ContentSectionHeader } from '@/components/ContentSection';
import { SectionHeaderSize } from '@/components/SectionHeader';
import ApplicationShareButton from 'containers/ApplicationContainer/components/ApplicationShareButton';

export default function GameScoringSummary() {
  const [{ game }, {}] = useGameContainer();
  const { isSmallScreen } = useScreenSize();

  if (!('scoringGameEventGroupings' in game) || game.scoringGameEventGroupings.length === 0) return null;

  const scoringByPeriod = groupBy(game.scoringGameEventGroupings, ({ periodText }) => periodText || '');

  const getTeam = (teamName?: string) => game.gameTeams.find(gameTeam => gameTeam.team.name === teamName);

  return (
    <ContentSection>
      <ContentSectionHeader size={SectionHeaderSize.LARGE} right={<ApplicationShareButton path={game.webScorebookCastPath} />}>
        Scoring Summary
      </ContentSectionHeader>
      {Object.keys(scoringByPeriod).map((period, i) => (
        <Table
          className={styles.ScoringSummaryTable}
          key={i}
          noBottomBorder={i !== Object.keys(scoringByPeriod).length - 1}
          reducedPadding
          v2
        >
          <TableHead
            headers={isSmallScreen ? ['', 'score'] : ['', game.gameTeams[0].team.abbrev || 'AWAY', game.gameTeams[1].team.abbrev || 'HOME']}
          >
            <th className={styles.ScoringSummaryPeriod}>{period}</th>
          </TableHead>
          <TableBody>
            {scoringByPeriod[period].map((score, j) => (
              <TableRow key={j}>
                <td className={styles.ScoringSummaryTeamColumn}>
                  <div className={styles.TeamSection}>
                    <TeamImage alt={score.name} src={score.image} />
                    {score.name}
                  </div>
                </td>
                <td className={styles.ScoringSummaryEventColumn}>{score.eventText}</td>
                {isSmallScreen ? (
                  <>
                    <td className={styles.ScoringSummaryScoreColumn}>
                      <span className={cn({ [styles.ScoringSummaryCurrentTeam]: getTeam(score.teamName)?.id === game.gameTeams[0].id })}>
                        {score.awayScore}
                      </span>
                      &nbsp;-&nbsp;
                      <span className={cn({ [styles.ScoringSummaryCurrentTeam]: getTeam(score.teamName)?.id === game.gameTeams[1].id })}>
                        {score.homeScore}
                      </span>
                    </td>
                  </>
                ) : (
                  <>
                    <td
                      className={cn(styles.ScoringSummaryScoreColumn, {
                        [styles.ScoringSummaryCurrentTeam]: getTeam(score.teamName)?.id === game.gameTeams[0].id
                      })}
                    >
                      {score.awayScore}
                    </td>
                    <td
                      className={cn(styles.ScoringSummaryScoreColumn, {
                        [styles.ScoringSummaryCurrentTeam]: getTeam(score.teamName)?.id === game.gameTeams[1].id
                      })}
                    >
                      {score.homeScore}
                    </td>
                  </>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ))}
      <ContentSectionFooterButton href={game.webScorebookCastPath}>See ScorebookCast</ContentSectionFooterButton>
    </ContentSection>
  );
}
